
import { defineComponent, WatchStopHandle } from "vue";
import { routes } from "../../router";
import NavigationDrawerAppIcon from "./NavigationDrawerAppIcon.vue";

export default defineComponent({
  name: "NavigationDrawer",
  props: {
    drawer: Boolean,
    fromLeft: Boolean,
  },
  components: {
    NavigationDrawerAppIcon,
  },
  emits: ["hide"],
  data() {
    return {
      routes: routes,
      watchers: [] as WatchStopHandle[],
    };
  },
  mounted() {
    // hide drawer on click outside of drawer, escape key or when route changes
    window.addEventListener("click", this.onClick);
    window.addEventListener("keydown", this.hideDrawerOnEscape);
    this.watchers.push(
      this.$watch(
        () => this.$route,
        () => {
          this.$emit("hide");
        }
      )
    );
  },
  beforeUnmount() {
    window.removeEventListener("click", this.onClick);
    window.removeEventListener("keydown", this.hideDrawerOnEscape);
    for (const removeWatcher of this.watchers) {
      removeWatcher();
    }
  },
  methods: {
    onClick(event: Event) {
      const target = event.target as HTMLElement;
      if (target.classList.contains("modal")) {
        this.$emit("hide");
      }
    },
    hideDrawerOnEscape(event: KeyboardEvent) {
      if (event.keyCode === 27) {
        this.$emit("hide");
      }
    },
  },
});
